/**
 * Sidebar del Super Admin — mismo shell que el resto del producto (Polaris
 * `<Navigation>`), calcado del patrón de `AdsNavigation`/`CallCenterNavigation`
 * ("módulo-as-app", NO un sidebar custom). Vive dentro del `<Frame>` que arma
 * `AdminLoginGate`. La sección activa se decide por la URL (/admin, /admin/clientes…),
 * en línea con `activeSection` de `SuperAdminPage`.
 */
import { useLocation } from 'react-router-dom';
import { Navigation } from '@/lib/polaris';
import {
  CashDollarIcon,
  EmailIcon,
  PersonIcon,
  PersonAddIcon,
  PackageIcon,
  SettingsIcon,
  LinkIcon,
  LightbulbIcon,
  PageClockIcon,
} from '@/lib/polaris-icons';
import { SUPER_ADMIN_ROUTES } from '@/lib/admin/lasSeccionesDelAdmin';

export function SuperAdminNavigation() {
  const location = useLocation();
  const path = (location.pathname || '/admin').replace(/\/+$/, '') || '/admin';

  const mk = (url: string, label: string, icon: typeof CashDollarIcon) => ({
    url,
    label,
    icon,
    // "Mi negocio" (/admin) es prefijo de las demás → match exacto; el resto por prefijo.
    matches: url === '/admin' ? path === '/admin' : path === url || path.startsWith(url + '/'),
  });

  return (
    <Navigation location={location.pathname}>
      <Navigation.Section
        title="Super Admin"
        items={[
          mk(SUPER_ADMIN_ROUTES.negocio, 'Mi negocio', CashDollarIcon),
          mk(SUPER_ADMIN_ROUTES.clientes, 'Clientes', PersonIcon),
          mk(SUPER_ADMIN_ROUTES.invitaciones, 'Invitaciones', EmailIcon),
          mk(SUPER_ADMIN_ROUTES.altas, 'Altas', PersonAddIcon),
          mk(SUPER_ADMIN_ROUTES.planes, 'Planes', PackageIcon),
          mk(SUPER_ADMIN_ROUTES.propuestas, 'Propuestas', LightbulbIcon),
        ]}
      />
      <Navigation.Section
        title="Sistema"
        separator
        items={[
          /*
           * Va en «Sistema» y no arriba: no es una parte del negocio que se mira todos los días,
           * es el registro de lo que el producto todavía no ofrece. Se entra cuando uno se
           * pregunta «¿qué habíamos sacado del menú?».
           */
          mk(SUPER_ADMIN_ROUTES.sinConstruir, 'Sin construir', PageClockIcon),
          mk(SUPER_ADMIN_ROUTES.integraciones, 'Integraciones', LinkIcon),
          mk(SUPER_ADMIN_ROUTES.configuracion, 'Configuración', SettingsIcon),
        ]}
      />
    </Navigation>
  );
}
